
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"biddingTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"biddingTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"titleRu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPublic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialRateAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bidStepAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prolongationRuleAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reducedPriceAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAnalysisMarket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowRaising"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenderingForPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMultistage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFrameAuction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFrameFirstStage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showSubscribedUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowCreation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withoutPublication"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowCounterOffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowPriceRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recalcTotalSummByReducedPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlyOneLotPerTender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimalQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saleWithDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saleInParts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canChangeCurrencyOwner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupedLotsEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasLimitBidPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowedCurrenciesSelectionByOrganizer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paidCommercialBidding"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":735}};
    doc.loc.source = {"body":"{\n  biddingTypes {\n    biddingTypeId\n    titleRu\n    oldCode\n    isSale\n    isPublic\n    initialRateAvailable\n    bidStepAvailable\n    prolongationRuleAvailable\n    reducedPriceAvailable\n    isRating\n    isAnalysisMarket\n    analogAvailable\n    allowRaising\n    tenderingForPercentage\n    isMultistage\n    isFrameAuction\n    isFrameFirstStage\n    showSubscribedUsers\n    allowCreation\n    withoutPublication\n    allowCounterOffer\n    allowPriceRequest\n    recalcTotalSummByReducedPrice\n    onlyOneLotPerTender\n    minimalQuantity\n    saleWithDiscount\n    saleInParts\n    canChangeCurrencyOwner\n    #dontCopySuppliers\n    groupedLotsEnabled\n    hasLimitBidPrice\n    allowedCurrenciesSelectionByOrganizer\n    paidCommercialBidding\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
